export const OVERWRITTEN_TYPE = [
  'text',
  'tagbox',
  'comment',
  'dropdown',
  'boolean',
  'checkbox',
  'file',
];
